module.exports = __webpack_public_path__ + "static/media/new-laptop.e0d0f022.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-laptop.jpg
// module id = 40
// module chunks = 3